import React, { useCallback, useEffect } from 'react';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import { FavoriteResource, Resource } from '@monorepo/shared/src/providers/ResourcesProvider/types';
import useResourcesStore from '@monorepo/shared/src/graph/state/query-hooks/use-resources';
import useFavoriteResourcesStore from 'graph/state/query-hooks/use-favorite-resources';
import WithQuery from '@monorepo/shared/src/components/common/WithQuery';
import NoContent from '@monorepo/shared/src/components/common/NoContent';
import ResourcesList from '@monorepo/shared/src/components/modules/Resources/ResourcesList';
import ResourcesGrid from './ResourcesGrid';

const AllResources: React.FC = () => {
  const [resourceStore, { pinResource, unpinResource }] = useResourcesStore();
  const [favoriteResourcesStore] = useFavoriteResourcesStore();
  const [
    { filteredResources, pinnedResources },
    { setResources, setPinnedResources, setPinActions, addPinnedResource, removePinnedResource },
  ] = useResources();

  const handleOnPinClick = useCallback(
    async (resource: Resource, pinnedResourceId: number | undefined) => {
      if (pinnedResourceId) {
        try {
          await unpinResource(pinnedResourceId);
          setPinActions('UNPINNING');
          removePinnedResource(pinnedResourceId);
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          const result = (await pinResource(resource.id)) as FavoriteResource;
          const newPinnedResource = { ...result, resource } as FavoriteResource;
          setPinActions('PINNING');
          addPinnedResource(newPinnedResource);
        } catch (error) {
          console.log(error);
        }
      }
    },
    [unpinResource, pinResource, setPinActions, removePinnedResource, addPinnedResource]
  );

  useEffect(() => {
    setResources(resourceStore.resources);
  }, [resourceStore.isLoading]);

  useEffect(() => {
    setPinnedResources(favoriteResourcesStore.resources);
  }, [favoriteResourcesStore.isLoading]);

  return (
    <WithQuery
      loading={resourceStore.isLoading || favoriteResourcesStore.isLoading}
      error={resourceStore.error || favoriteResourcesStore.error}
      ErrorComponent={NoContent}
    >
      <ResourcesGrid>
        <ResourcesList
          resources={filteredResources}
          pinnedResources={pinnedResources}
          onPinClick={handleOnPinClick}
        />
      </ResourcesGrid>
    </WithQuery>
  );
};

export default AllResources;
